import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {Field, formValueSelector} from 'redux-form';
import { TextField } from 'redux-form-material-ui';

import IconButton from 'material-ui/IconButton';
import CreateIcon from 'material-ui/svg-icons/content/create';
import Dialog from 'material-ui/Dialog';
import {RaisedButton} from "material-ui";
import { changePort } from 'actions/regions/ports';

import { formName } from 'data/formNames';

const styles = {
    dialog: {
        contentStyle: { width: 'auto', padding: '18px' },
    },
    textField: {
        floatingLabelStyle: { fontSize: '12px' },
    },
    button: {
        style: { background: '#7FC931' },

    }
};


class Other extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };

        this.toggleDialog = this.toggleDialog.bind(this);
    }

    toggleDialog() {
        this.setState({
            open: !this.state.open,
        });
    }

    render() {
        const { open } = this.state;
        const { additionalDescription } = this.props;

        return (
            <Fragment>
                <Dialog
                    open={open}
                    contentStyle={styles.dialog.contentStyle}
                    onRequestClose={this.toggleDialog}
                >
                    <Field
                        name={'additionalDescription'}
                        component={TextField}
                        floatingLabelText='Other'
                        multiLine
                        fullWidth
                        floatingLabelStyle={styles.textField.floatingLabelStyle}
                    />
                    <RaisedButton
                        label="Save"
                        style={styles.button.style}
                        primary
                        onClick={() => {
                            this.toggleDialog();
                        }}
                    />
                </Dialog>

                <div className="main__title">
                    other
                </div>

                <div className="other">
                    { additionalDescription }

                    <div className="other-change">
                        <IconButton
                            iconStyle={{ color: '#CBCBCB' }}
                            onClick={this.toggleDialog}>
                            <CreateIcon/>
                        </IconButton>
                    </div>
                </div>
            </Fragment>
        );
    }
}

Other.propTypes = {
    additionalDescription: PropTypes.string,
};

Other.defaultProps = {
    additionalDescription: '',
};

const selector = formValueSelector(formName.portUpdate);
export default connect(
    (state) => {
        return {
            additionalDescription: selector(state, 'additionalDescription'),
        }
    },
    dispatch => bindActionCreators({
        changePort
    }, dispatch),
)(Other);


// WEBPACK FOOTER //
// ./app/components/Regions/Port/Other.jsx